import { render, staticRenderFns } from "./WorkOrderEvaluation.vue?vue&type=template&id=0ff38c80&scoped=true"
import script from "./WorkOrderEvaluation.vue?vue&type=script&lang=js"
export * from "./WorkOrderEvaluation.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderEvaluation.vue?vue&type=style&index=0&id=0ff38c80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff38c80",
  null
  
)

export default component.exports